import SendIcon from '@mui/icons-material/Send';
import * as React from 'react';
import {
  MessageBubble,
  MessageContainer,
  SendIconContainer,
} from './ChatSendMessage.styles';

interface Props {
  onSend: (text: string) => void;
  placeholder: string;
}

const ChatList = (props: Props) => {
  const [text, setText] = React.useState('');
  const send = () => {
    props.onSend(text);
    setText('');
  };
  const numLines = text.split('\n').length;
  return (
    <MessageContainer>
      <MessageBubble
        data-testid={'chat-message-input'}
        text={text}
        value={text}
        onChange={(event) => setText(event.currentTarget.value)}
        placeholder={props.placeholder}
        rows={Math.min(4, numLines)}
      ></MessageBubble>
      <SendIconContainer data-testid="report-message-send-wrapper">
        <SendIcon
          fontSize="inherit"
          onClick={send}
          data-testid={'chat-message-send'}
        />
      </SendIconContainer>
    </MessageContainer>
  );
};

export default ChatList;
